import React from 'react';
import { Learn3XLink, StyledCard } from './CircularProgressBar.styled';
import { RewardSubscriptionMonthDescriptionProps } from './types';
import { replacePlaceholders } from '../Utils/helper';

class RewardSubscriptionMonthDescription extends React.Component<RewardSubscriptionMonthDescriptionProps> {
    render() {
        const {
            value,
            voucherValue,
            maxMonths,
            handleOpenSubscriptionRewardPopup,
            notQualifyForRewardThisMonth,
            translationConfig = {
                voucherTargetAmount: '',
                monthsComplete: '',
                voucherEarned: '',
                learnMore: '',
                learn3xMore: '',
                callToAction: '',
                notQualify: '',
                approximateMonthly: '',
                approximateTotal: '',
                currentlyTrack: '',
                loyaltyLogoBlack: '',
            },
            learnMoreConfig = {
                tagLine: '',
                cardOneDescription: '',
                cardOneVoucherAmount: '',
                cardTwoDescription: '',
                cardTwoVoucherAmount: '',
                header: '',
                loyaltyLogoWhite: '',
                loyaltyBanner: '',
                learnMore: '',
            },
            currencyAbbreviate = false,
            currencyFormat = () => {},
        } = this.props;

        let popupText = '';
        const minVoucher = 50;
        const maxVoucher = 150;
        if (voucherValue === minVoucher && !notQualifyForRewardThisMonth) {
            popupText = translationConfig.learn3xMore;
        } else if (voucherValue === maxVoucher || notQualifyForRewardThisMonth) {
            popupText = learnMoreConfig.learnMore;
        } else if (voucherValue === null || voucherValue === undefined) {
            popupText = translationConfig.learnMore;
        }
        const monthsCompleteText = replacePlaceholders(translationConfig.monthsComplete, {
            completed_months: value,
            total_months: maxMonths,
        });

        const voucherEarned = voucherValue
            ? currencyFormat(voucherValue, true, currencyAbbreviate)
            : currencyFormat(0, true, currencyAbbreviate);
        const voucherEarnedText = translationConfig.voucherEarned.replace(
            '%currency_symbol%%currency_amount%',
            `${voucherEarned}`,
        );

        return (
            <StyledCard>
                <img className="reward-logo" src={translationConfig.loyaltyLogoBlack} alt="Rewards Logo" />
                {value === maxMonths ? (
                    <div className="info-item">{voucherEarnedText}</div>
                ) : (
                    <div className="info-item">{monthsCompleteText}</div>
                )}
                <Learn3XLink id="learnMore" onClick={handleOpenSubscriptionRewardPopup}>
                    <u>{popupText}</u>
                </Learn3XLink>
            </StyledCard>
        );
    }
}

export default RewardSubscriptionMonthDescription;
export { RewardSubscriptionMonthDescription };
